<template>
   <v-app id="inspire">
      <v-toolbar
         v-if="!isLoginRoute"
         app
         class="app-header"
         dark
         max-height="94"
         >
         <div
            v-if="currentUser"
            class="app-header__brand"
            role="button"
            tabindex="0"
            @click="homepageRedirect"
            @keyup.enter="homepageRedirect"
         >
            <v-img
               class="app-header__brand-logo"
               src="./assets/figma/logo.svg"
               contain
               max-width="260"
            ></v-img>
         </div>
            <v-spacer></v-spacer>
            <!-- <v-btn
               :to="{name: 'login'}"
               v-if="!currentUser"
               class="menu-home-item my-4 white--text text-capitalize subtitle-1 font-weight-light"
               dark
               text
               size="default"
               >
               {{$t('MENU.LBL_SIGN_IN')}}
               <v-icon right dark>mdi-login</v-icon>
               </v-btn> -->
            <!-- <v-btn
               :to="{name: 'register'}"
               v-if="!currentUser"
               class="menu-home-item my-4 white--text text-capitalize subtitle-1 font-weight-light"
               dark
               text
               size="default"
               >
               {{$t('MENU.LBL_SIGN_UP')}}
               <v-icon right dark>mdi-account-plus</v-icon>
               </v-btn> -->
               <v-toolbar-items class="hidden-md-and-down app-header__desktop-nav">
                  <v-btn
                     v-if="currentUser"
                     class="menu-home-item my-4 white-text text-capitalize subtitle-1 font-weight-light v-btn-menu"
                     dark
                     text
                     size="default"
                     @click="homepageRedirect"
                  >
                     {{$t('MENU.LBL_HOME')}}
                  </v-btn>
                  <div class="btn-group">
                    <v-btn v-if="currentUser && menuItems.includes('administration')"
                        class="dropdown-toggle my-4 white-text text-capitalize subtitle-1 font-weight-light v-btn-menu"
                        dark
                        text
                        size="default"
                        data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false"
                        >
                        {{$t('MENU.LBL_ADMIN')}}
                    </v-btn>
                    <div class="dropdown-menu" id="dropdown-admin">
                        <router-link
                            v-for="(item, i) in items"
                            :key="i"
                            class="list-item-menu dropdown-item font-weight-light"
                            :to="item.to"
                        >
                           {{ item.title }} 
                        </router-link>
                    </div>
                  </div>
                  <div class="btn-group">
                     <v-btn
                        v-if="currentUser && menuItems.includes('targetPlans')"
                        class="dropdown-toggle my-4 white-text text-capitalize subtitle-1 font-weight-light v-btn-menu"
                        dark
                        text
                        size="default"
                        data-toggle="dropdown"
                        aria-haspopup="true" 
                        aria-expanded="false"
                     >
                        {{$t('MENU.LBL_TARGET_PLANS')}}
                     </v-btn>
                     <div class="dropdown-menu" id="dropdown-targetplans">
                        <router-link
                            v-for="(targetplan_item, i) in targetPlan_items"
                            :key="i"
                            class="list-item-menu dropdown-item font-weight-light"
                            :to="targetplan_item.to"
                            v-show="targetplan_item.show"
                        >
                           {{ targetplan_item.title }}
                        </router-link>
                     </div>
                  </div>
                  <div class="btn-group">
                    <v-btn
                        v-if="currentUser && menuItems.includes('surveillance')"
                        class="dropdown-toggle my-4 white-text text-capitalize subtitle-1 font-weight-light v-btn-menu"
                        dark
                        text
                        size="default"
                        data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false"
                        >
                        {{$t('MENU.LBL_SUBJECTS_SURVEILLANCE')}}
                    </v-btn>
                    <div class="dropdown-menu" id="dropdown-targetplans">
                        <router-link
                            v-for="(subjectsSurveillance_item, i) in subjectsSurveillance_items"
                            :key="i"
                            class="list-item-menu dropdown-item font-weight-light"
                            :to="subjectsSurveillance_item.to"
                            v-show="subjectsSurveillance_item.show"
                        >
                           {{ subjectsSurveillance_item.title }}
                        </router-link>
                    </div>
                  </div>
                  <div class="btn-group">
                    <v-btn
                        v-if="currentUser && menuItems.includes('inspectionProcedure')"
                        class="dropdown-toggle my-4 white-text text-capitalize subtitle-1 font-weight-light v-btn-menu"
                        dark
                        text
                        size="default"
                        data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false"
                     >
                        {{$t('MENU.LBL_INSPECTION_PROCEDURE')}}
                    </v-btn>
                    <div class="dropdown-menu" id="dropdown-inspectionProcedure">
                        <router-link
                            v-for="(inspectionProcedure_item, i) in inspectionProcedure_items"
                            :key="i"
                            class="list-item-menu dropdown-item font-weight-light"
                            :to="inspectionProcedure_item.to"
                            v-show="inspectionProcedure_item.show"
                        >
                           {{ inspectionProcedure_item.title }}
                        </router-link>
                    </div>
                  </div>
                  <v-toolbar-items class="hidden-md-and-down app-header__desktop-nav">
                     <div class="btn-group">
                        <v-btn
                           v-if="currentUser && (menuItems.includes('tickets') || menuItems.includes('reports'))"
                           class="dropdown-toggle my-4 white-text text-capitalize subtitle-1 font-weight-light v-btn-menu"
                           dark
                           text
                           size="default"
                           data-toggle="dropdown"
                           aria-haspopup="true" aria-expanded="false"
                        >
                           {{$t('MENU.LBL_IT_HELP_DESK')}}
                        </v-btn>
                        <div class="dropdown-menu" id="dropdown-helpdesk">
                           <router-link
                              v-for="(helpdesk_item, i) in helpdesk_items"
                              :key="i"
                              class="list-item-menu dropdown-item font-weight-light"
                              :to="helpdesk_item.to"
                              v-show="helpdesk_item.show"
                           >
                              {{ helpdesk_item.title }}
                           </router-link>
                        </div>
                     </div>
                  </v-toolbar-items>
                    <div class="btn-group">
                       <v-menu
                          v-if="currentUser"
                          offset-y
                          left
                          content-class="user-menu-content"
                       >
                          <template v-slot:activator="{ on, attrs }">
                             <v-btn
                                id="user_menu"
                                class="menu-home-item my-4 white--text text-capitalize subtitle-1 font-weight-light v-btn-menu user-menu-btn"
                                v-bind="attrs"
                                v-on="on"
                                v-bind:class="emptyUserDetailsCssClass"
                                dark
                                text
                                size="default"
                             >
                                <span class="user-menu-avatar">
                                   <img src="./assets/figma/profile-icon-dropdown.svg" alt="" class="user-menu-avatar-icon" />
                                </span>
                                <span class="user-menu-meta">
                                   <span class="user-menu-name">{{ userFirstLastName }}</span>
                                   <span class="user-menu-role">{{ userRoleLabel }}</span>
                                </span>
                                <v-icon dark small class="user-menu-caret">mdi-menu-down</v-icon>
                             </v-btn>
                          </template>
                          <v-list dense class="user-menu-list">
                             <v-list-item :to="toRouteForUserProfile" class="user-menu-item user-menu-item-profile" link>
                                <v-list-item-title>{{$t('AUTHENTICATION.LBL_PROFILE')}}</v-list-item-title>
                                <img src="./assets/figma/profile-icon-dropdown.svg" alt="" class="user-menu-item-icon user-menu-item-icon-profile" />
                             </v-list-item>
                             <v-list-item @click="logOut" class="user-menu-item" link>
                                <v-list-item-title>{{$t('MENU.LBL_SIGN_OUT')}}</v-list-item-title>
                                <img src="./assets/figma/logout-icon-dropdown.svg" alt="" class="user-menu-item-icon" />
                             </v-list-item>
                             <v-menu offset-y left content-class="user-menu-lang-content">
                                <template v-slot:activator="{ on, attrs }">
                                   <v-list-item
                                      class="user-menu-item user-menu-lang-item"
                                      v-bind="attrs"
                                      v-on="on"
                                      link
                                   >
                                      <v-list-item-title>Јазик</v-list-item-title>
                                      <div class="user-menu-lang-value">
                                         <img src="./assets/figma/language-icon-dropdown.svg" alt="" class="user-menu-language-icon" />
                                      </div>
                                   </v-list-item>
                                </template>
                                <v-list dense>
                                   <v-list-item
                                      v-for="(locale, i) in $i18n.availableLocales"
                                      :key="i"
                                      @click="$i18n.locale = locale"
                                   >
                                      <v-list-item-title>{{ locale }}</v-list-item-title>
                                   </v-list-item>
                                </v-list>
                             </v-menu>
                          </v-list>
                       </v-menu>
                    </div>
         </v-toolbar-items>
         <div v-if="currentUser" class="hidden-lg-and-up app-header__mobile-trigger">
            <v-app-bar-nav-icon color="white" @click="snowDrawer = !snowDrawer"></v-app-bar-nav-icon>
         </div>
      </v-toolbar>
      <v-navigation-drawer
         v-if="!isLoginRoute"
         id="navigation-drawer"
         v-model="snowDrawer"
         temporary
         absolute
         right
         hide-overlay
         >
         <v-list v-if="currentUser" dense class="app-header__mobile-home">
            <v-list-item link @click="goHomeFromDrawer">
               <v-list-item-title>{{$t('MENU.LBL_HOME')}}</v-list-item-title>
            </v-list-item>
         </v-list>
         <v-expansion-panels>
            <v-expansion-panel
               v-show="currentUser && (menuItems.includes('tickets') || menuItems.includes('reports'))"
            >
               <v-expansion-panel-header>
                  {{$t('MENU.LBL_IT_HELP_DESK')}}
               </v-expansion-panel-header>
               <v-expansion-panel-content>
                  <router-link
                     v-for="(helpdesk_item, i) in helpdesk_items"
                     :key="i"
                     class="list-item-menu dropdown-item font-weight-light"
                     :to="helpdesk_item.to"
                     v-show="helpdesk_item.show"
                  >
                     {{ helpdesk_item.title }}
                  </router-link>
               </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel
               v-show="currentUser && menuItems.includes('surveillance')"
            >
               <v-expansion-panel-header>
                  {{$t('MENU.LBL_SUBJECTS_SURVEILLANCE')}}
               </v-expansion-panel-header>
               <v-expansion-panel-content>
                  <router-link
                     v-for="(subjectsSurveillance_item, i) in subjectsSurveillance_items"
                     :key="i"
                     class="list-item-menu dropdown-item font-weight-light"
                     :to="subjectsSurveillance_item.to"
                     v-show="subjectsSurveillance_item.show"
                  >
                     {{ subjectsSurveillance_item.title }}
                  </router-link>
               </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel
               v-show="currentUser && menuItems.includes('inspectionProcedure')"
            >
               <v-expansion-panel-header>
                  {{$t('MENU.LBL_INSPECTION_PROCEDURE')}}
               </v-expansion-panel-header>
               <v-expansion-panel-content>
                  <router-link
                     v-for="(inspectionProcedure_item, i) in inspectionProcedure_items"
                     :key="i"
                     class="list-item-menu dropdown-item font-weight-light"
                     :to="inspectionProcedure_item.to"
                     v-show="inspectionProcedure_item.show"
                  >
                     {{ inspectionProcedure_item.title }}
                  </router-link>
               </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel
               v-show="currentUser && menuItems.includes('targetPlans')"
               >
               <v-expansion-panel-header>
                  {{$t('MENU.LBL_TARGET_PLANS')}}
               </v-expansion-panel-header>
               <v-expansion-panel-content>
                  <router-link
                     v-for="(targetplan_item, i) in targetPlan_items"
                     :key="i"
                     class="list-item-menu dropdown-item font-weight-light"
                     :to="targetplan_item.to"
                     v-show="targetplan_item.show"
                  >
                     {{ targetplan_item.title }}
                  </router-link>
               </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel
               v-show="currentUser && menuItems.includes('administration')"
               >
               <v-expansion-panel-header>
                  {{$t('MENU.LBL_ADMIN')}}
               </v-expansion-panel-header>
               <v-expansion-panel-content>
                  <router-link
                     v-for="(item, i) in items"
                     :key="i"
                     class="list-item-menu dropdown-item font-weight-light"
                     :to="item.to"
                  >
                     {{ item.title }} 
                  </router-link>
               </v-expansion-panel-content>
            </v-expansion-panel>
         </v-expansion-panels>
         <v-list
            nav
            dense
            >
            <v-list-item-group
               active-class="deep-purple--text text--accent-4"
               >
               <v-list-item v-show="currentUser" class="user-menu-item user-menu-item-profile" :to="toRouteForUserProfile" link>
                  <v-list-item-title>{{ userFirstLastName }}</v-list-item-title>
                  <v-icon right>mdi-account-circle</v-icon>
               </v-list-item>
               <v-list-item v-show="currentUser" class="user-menu-item" @click="logOut" link>
                  <v-list-item-title>{{$t('MENU.LBL_SIGN_OUT')}}</v-list-item-title>
                  <v-icon right>mdi-logout</v-icon>
               </v-list-item>
               <v-menu offset-y left>
                  <template v-slot:activator="{ on, attrs }">
                     <v-list-item
                        class="user-menu-item user-menu-lang-item"
                        v-bind="attrs"
                        v-on="on"
                        link
                     >
                        <v-list-item-title>Јазик</v-list-item-title>
                        <div class="user-menu-lang-value">
                           <span>{{ $i18n.locale }}</span>
                           <v-icon right small>mdi-menu-down</v-icon>
                        </div>
                     </v-list-item>
                  </template>
                  <v-list dense>
                     <v-list-item
                        v-for="(locale, i) in $i18n.availableLocales"
                        :key="i"
                        @click="$i18n.locale = locale"
                     >
                        <v-list-item-title>{{ locale }}</v-list-item-title>
                     </v-list-item>
                  </v-list>
               </v-menu>
            </v-list-item-group>
         </v-list>
      </v-navigation-drawer>
      <v-content>
         <v-breadcrumbs
            v-if="!isLoginRoute"
            :items="breadCrumbs"
            divider=">"
            large
            >
            <template v-slot:item="props">
               <router-link :to="props.item.href" v-if="!props.item.disabled">
                  <v-breadcrumbs-item
                     :class="[props.item.disabled && 'disabled']"
                     >
                     {{ props.item.text }}
                  </v-breadcrumbs-item>
               </router-link>
               <v-breadcrumbs-item
                  :class="[props.item.disabled && 'disabled']"
                  v-else
                  >
                  {{ props.item.text }}
               </v-breadcrumbs-item>
            </template>
         </v-breadcrumbs>
         <router-view/>
      </v-content>
      <v-footer v-if="!isLoginRoute" class="app-footer white--text" padless>
         <div class="app-footer__inner">
            <div class="app-footer__center">
               <img src="./assets/figma/logo_for_footer.svg" alt="" class="app-footer__logo" />
            </div>
            <div class="app-footer__right">
               <div class="app-footer__line">
                  <img src="./assets/figma/footer-icon-location.svg" alt="" class="app-footer__icon" />
                  <span>
                     ул. Филип Втори Македонски бр. 11<br />
                     1000, Скопје, Република Северна Македонија
                  </span>
               </div>
               <div class="app-footer__line">
                  <img src="./assets/figma/footer-icon-phone.svg" alt="" class="app-footer__icon" />
                  <span><a href="tel:+389023200999">+389 (0) 2 3200 999</a></span>
               </div>
               <div class="app-footer__line">
                  <img src="./assets/figma/footer-icon-email.svg" alt="" class="app-footer__icon" />
                  <span><a href="mailto:cabinet@mdt.gov.mk">cabinet@mdt.gov.mk</a></span>
               </div>
            </div>
         </div>
         <div class="app-footer__bottom">
            <button
               id="fetch_user_guidance"
               class="app-footer__guidance"
               type="button"
               @click="getUserGuidanceDocuments"
            >
               Кориснички упатства
            </button>
            <span class="app-footer__divider">|</span>
            <span>© 2026 Министерство за дигитална трансформација</span>
            <span class="app-footer__divider">|</span>
            <span>Сите права задржани</span>
         </div>
      </v-footer>
   </v-app>
</template>
<script>
   // import UserService from './services/user.service';
   
   export default {
   name: 'App',
   data: () => ({
       showMenu:true,
       // when true the drawer is visible
       snowDrawer: false
   }),
   components: {
      
   },
   created() {
   },
   
   computed: {
      isLoginRoute() {
         return this.$route && this.$route.path === '/login';
      },
      currentUser() {
          return this.$store.state.auth.user;
      },
       menuItems(){
           let menuItemsForUser = [];
   
           if(this.currentUser != null)
               menuItemsForUser = this.currentUser.menuItems;
   
           return menuItemsForUser;
       },
       userFirstLastName(){
           return (this.currentUser && this.currentUser.userDetails) ? `${this.currentUser.userDetails.firstName} ${this.currentUser.userDetails.lastName}` : null;
       },
       userRoleLabel() {
           if (this.currentUser && this.currentUser.role && this.currentUser.role.name) {
               return this.$t('USERS.ROLES.' + this.currentUser.role.name);
           }
           return 'Admin';
       },
       toRouteForUserProfile(){
           return this.currentUser && this.currentUser.userDetails ? {name: 'profile'} : null
       },
       emptyUserDetailsCssClass(){
           return  this.currentUser && !this.currentUser.userDetails ? 'not_clickable' : null;
       },
       items() {
         return [
               { title: this.$t('MENU.LBL_INSTITUTIONS'), to: { name: 'institutions'} },
               { title: this.$t('MENU.LBL_SECTORS'), to: { name: 'sectors'} },
               { title: this.$t('MENU.LBL_USERS'), to: { name: 'users'} },
               // { title: this.$t('MENU.LBL_REGIONS'), to: { name: '' } },
               // { title: this.$t('MENU.LBL_MUNICIPALITIES'), to: { name: ''} },
           ]
       },
       helpdesk_items() {
           return [
               { title: this.$t('MENU.LBL_TICKETS_LIST'), to: { name: 'tickets'}, show: this.menuItems ? this.menuItems.includes('tickets') : false  },
           ]
       },
       subjectsSurveillance_items() {
           return [
               { title: this.$t('MENU.LBL_SUBJECTS'), to: { name: 'subjects'}, show: true },
               { title: this.$t('MENU.LBL_SUBJECT_SUBSIDIARIES'), to: { name: 'subjectSubsidiaries' }, show: true  },
           ]
       },
       targetPlan_items() {
           return [
               { title: this.$t('MENU.LBL_YEARLY_PLANS_LIST'), to: { name: 'yearlyPlans'}, show: true  },
               { title: this.$t('MENU.LBL_MONTHLY_PLANS_LIST'), to: { name: 'monthlyPlans'}, show: true  },
               { title: this.$t('MENU.LBL_RISKS'), to: { name: 'risks' }, show: true  },
               { title: this.$t('MENU.LBL_RISK_SPECIFIC_ELEMENTS'), to: { name: 'riskSpecificElements' }, show: true  },
               { title: this.$t('MENU.LBL_RISK_CRITERIA'), to: { name: 'riskCriteria' }, show: true  }, 
               { title: this.$t('MENU.LBL_WEIGHT_SURVEILLANCE'), to: { name: 'weightSurveillance' }, show: true  },   
           ]
       },
       inspectionProcedure_items() {
           return [
               { title: this.$t('MENU.LBL_INSPECTION_WORK_ORDER'), to: { name: 'inspectionWorkOrders'}, show: true  },
               { title: this.$t('MENU.LBL_INSPECTION_CASE'), to: { name: 'inspectionCases'}, show: true  },
               { title: this.$t('MENU.LBL_INSPECTION_REPORT'), to: { name: 'inspectionReports'}, show: true  },
               { title: this.$t('MENU.LBL_INSPECTION_CONCLUSION'), to: { name: 'inspectionConclusions'}, show: true  },
               { title: this.$t('MENU.LBL_CHECKLISTS'), to: { name: 'checklists'}, show: true  },
               { title: this.$t('MENU.LBL_LAWS'), to: { name: 'laws' }, show: true  },
               { title: this.$t('MENU.LBL_REPORTS_LIST'), to: { name: 'reports'}, show: this.menuItems ? this.menuItems.includes('reports') : false },
           ]
       },
       breadCrumbs () {
           let pathArray = this.$route.path.split('/')
           pathArray.shift()
           const breadCrumbs = []
           // needed to handle the intermediary entries for nested vue routes
           let breadcrumb = ''
           let lastIndexFound = 0
           for (let i = 0; i < pathArray.length; ++i) {
               breadcrumb = `${breadcrumb}${'/'}${pathArray[i]}`
               if (this.$route.matched[i] &&
                   Object.hasOwnProperty.call(this.$route.matched[i], 'meta') &&
                   Object.hasOwnProperty.call(this.$route.matched[i].meta, 'breadCrumb')) {
                   breadCrumbs.push({
                       href: i !== 0 && pathArray[i - (i - lastIndexFound)]
                           ? '/' + pathArray[i - (i - lastIndexFound)] + breadcrumb
                           : breadcrumb,
                       // disabled: i + 1 === pathArray.length,
                       disabled: pathArray[i+1] == "" ? (i + 1 === (pathArray.length - 1)) : (i + 1 === pathArray.length),
                       text: this.$route.matched[i].meta.breadCrumb || pathArray[i]
                   })
                   lastIndexFound = i
                   breadcrumb = ''
               }
           }
           return breadCrumbs
       }
   },
   methods: {
     goHomeFromDrawer() {
         this.snowDrawer = false;
         this.homepageRedirect();
     },
     logOut() {
         var adminmenu = document.getElementById("dropdown-admin");
         adminmenu.classList.remove('show');
         var helpdesk_menu = document.getElementById("dropdown-helpdesk");
         helpdesk_menu.classList.remove('show');
         this.$store.dispatch('auth/logout');
         this.$store.dispatch('auth/logout');
         this.$router.push('/login');
     },
     homepageRedirect(){
           if (this.$route && this.$route.path === '/') {
             return;
           }
           this.$router.push('/').catch((err) => {
             if (err && err.name !== 'NavigationDuplicated') {
               throw err;
             }
           });
     },
    getUserGuidanceDocuments(){
      window.open('http://localhost:8081/userGuidance/', '_blank');
     }
   },
   updated() {
   }
   };
</script>
<style>
   .menu-home-item {
   text-decoration: none !important;
   }
   .required label::after {
   content: " *";
   color:red;
   }
   .app-header {
   background: linear-gradient(90deg, var(--color-accent-600) 0%, var(--color-primary-900) 52%);
   box-shadow: var(--shadow-md);
   height: 94px !important;
   max-height: 94px !important;
   z-index: 9999999 !important;
   }
   .app-header .v-toolbar__content {
   padding: 0 20px;
   min-height: 84px !important;
   height: 84px !important;
   }
   .app-header__brand {
   display: flex;
   align-items: center;
   cursor: pointer;
   min-width: 260px;
   height: 56px;
   }
   .app-header__brand-logo {
   filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
   }
   .app-header__desktop-nav {
   align-items: center;
   gap: 4px;
   }
   .app-header .v-btn-menu {
   min-width: 10px !important;
   padding: 0 8px !important;
   margin-top: 0 !important;
   margin-bottom: 0 !important;
   letter-spacing: 0;
   line-height: 1.2;
   text-transform: none !important;
   font-size: var(--font-size-md) !important;
   font-weight: 400 !important;
   }
   .app-header .dropdown-toggle::after {
   vertical-align: middle;
   margin-left: 6px;
   }
   .app-header .dropdown-menu {
   margin-top: 6px;
   border: 1px solid var(--color-slate-200);
   border-radius: var(--radius-md);
   box-shadow: var(--shadow-md);
   padding: 8px 0;
   min-width: 220px;
   }
   .app-header .dropdown-item {
   padding: 8px 14px;
   font-size: var(--font-size-sm);
   color: var(--color-slate-700);
   }
   .app-header .dropdown-item:hover,
   .app-header .dropdown-item:focus {
   color: var(--color-primary-900);
   background: var(--color-blue-50);
   }
   .user-menu-btn {
   display: flex;
   align-items: center;
   gap: 8px;
   border-radius: 999px !important;
   padding: 2px 8px !important;
   min-height: 38px;
   background: transparent !important;
   box-shadow: none !important;
   transition: background-color 0.15s ease-in-out;
   }
   .user-menu-btn.v-btn::before {
   opacity: 0 !important;
   }
   .user-menu-btn.v-btn--active::before {
   opacity: 0 !important;
   }
   .user-menu-btn:hover,
   .user-menu-btn:focus-visible {
   background: rgba(255, 255, 255, 0.12) !important;
   }
   .user-menu-content {
   border-radius: 12px !important;
   border: 1px solid #e2e8f0 !important;
   box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12) !important;
   overflow: hidden !important;
   }
   .user-menu-avatar {
   display: inline-flex;
   align-items: center;
   justify-content: center;
   width: 25px;
   height: 25px;
   flex: 0 0 25px;
   }
   .user-menu-avatar-icon {
   width: 25px;
   height: 25px;
   display: block;
   }
   .user-menu-meta {
   display: inline-flex;
   flex-direction: column;
   align-items: flex-start;
   line-height: 1.05;
   max-width: 150px;
   }
   .user-menu-name {
   max-width: 150px;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   display: inline-block;
   color: #ffffff;
   font-size: 0.8rem;
   font-weight: 400;
   margin-left: 10px;
   margin-right: 10px;
   text-transform: none;
   }
   .user-menu-role {
   color: #dbeafe;
   font-size: 0.76rem;
   font-weight: 400;
   text-transform: none;
   margin-left: 10px;
   margin-top: 3px;
   }
   .user-menu-caret {
   color: #e2e8f0 !important;
   margin-left: 0;
   }
   .user-menu-list {
   min-width: 238px;
   padding: 12px;
   border-radius: 12px !important;
   border: 0;
   box-shadow: none;
   background: #ffffff;
   }
   .user-menu-item {
   min-height: 35px;
   border-radius: 10px;
   margin-bottom: 8px;
   padding: 0 10px;
   }
   .user-menu-item .v-list-item__title {
   text-decoration: none !important;
   font-size: 1rem;
   font-weight: 400;
   color: #1b3471;
   }
   .user-menu-item-profile {
   text-decoration: none !important;
   background: #eff6ff;
   border-radius: 10px;
   min-height: 35px;
   margin-bottom: 12px;
   }
   .user-menu-item-profile:hover,
   .user-menu-item-profile:focus,
   .user-menu-item-profile:active {
   text-decoration: none !important;
   }
   .user-menu-item-profile .v-list-item__title {
   text-decoration: none !important;
   color: #1b3471;
   }
   .user-menu-item:hover {
   background: #eff6ff;
   }
   .user-menu-item-icon {
   width: 20px;
   height: 20px;
   margin-left: auto;
   display: block;
   }
   .user-menu-item-icon-profile {
   width: 25px;
   height: 25px;
   }
   .user-menu-lang-item {
   display: flex;
   align-items: center;
   justify-content: space-between;
   margin-top: 2px;
   margin-bottom: 0;
   }
   .user-menu-lang-value {
   display: inline-flex;
   align-items: center;
   gap: 0;
   margin-left: auto;
   }
   .user-menu-language-icon {
   width: 45px;
   height: 25px;
   display: block;
   }
   .user-menu-lang-item .v-list-item__title {
   font-size: 1rem;
   font-weight: 400;
   color: #1b3471;
   }
   .user-menu-lang-content {
   border-radius: 10px !important;
   border: 1px solid #e2e8f0 !important;
   box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12) !important;
   overflow: hidden !important;
   }
   .app-header .v-btn:focus-visible,
   .app-header .v-list-item:focus-visible {
   outline: 2px solid #ffffff;
   outline-offset: 2px;
   }
   .app-header__mobile-trigger {
   display: flex;
   align-items: center;
   margin-left: 4px;
   }
   .not_clickable, #logo_text {
   pointer-events: none;
   }
   .app-footer {
   background: #142748 !important;
   padding: 0 !important;
   }
   .app-footer__inner {
   width: 100%;
   max-width: 1200px;
   margin: 0 auto;
   padding: 34px 18px 22px;
   display: grid;
   grid-template-columns: auto 1fr;
   align-items: center;
   column-gap: 120px;
   transform: scale(0.8);
   transform-origin: center top;
   }
   .app-footer__guidance {
   display: inline;
   border: 0;
   background: transparent;
   color: #f8fafc;
   font-size: 1rem;
   font-weight: 600;
   line-height: 1.25;
   cursor: pointer;
   padding: 0;
   text-transform: none;
   text-decoration: underline;
   }
   .app-footer__guidance:hover,
   .app-footer__guidance:focus-visible {
   color: #d1d5db;
   outline: none;
   }
   .app-footer__center {
   display: flex;
   align-items: center;
   justify-content: flex-start;
   gap: 0;
   }
   .app-footer__logo {
   width: min(470px, 100%);
   height: auto;
   object-fit: contain;
   }
   .app-footer__right {
   justify-self: end;
   display: flex;
   flex-direction: column;
   gap: 14px;
   }
   .app-footer__line {
   display: flex;
   align-items: flex-start;
   gap: 10px;
   color: #f8fafc;
   font-size: 1rem;
   line-height: 1.3;
   font-weight: 500;
   }
   .app-footer__line a {
   color: #f8fafc;
   text-decoration: none;
   }
   .app-footer__line a:hover,
   .app-footer__line a:focus-visible {
   color: #d1d5db;
   text-decoration: underline;
   }
   .app-footer__icon {
   width: 26px;
   height: 26px;
   margin-top: 1px;
   flex: 0 0 26px;
   }
   .app-footer__bottom {
   width: 100%;
   text-align: center;
   color: #e2e8f0;
   font-size: 1rem;
   font-weight: 500;
   letter-spacing: 0;
   text-transform: none;
   padding: 4px 12px 20px;
   display: flex;
   align-items: center;
   justify-content: center;
   gap: 18px;
   flex-wrap: wrap;
   transform: scale(0.8);
   transform-origin: center top;
   }
   .app-footer__divider {
   color: rgba(255, 255, 255, 0.85);
   font-weight: 400;
   }
   #navigation-drawer{
   z-index: 10000000 !important;
   width: 340px !important;
   max-width: calc(100vw - 16px) !important;
   }
   .app-header__mobile-home .v-list-item__title {
   color: var(--color-slate-900);
   font-weight: 500;
   }
   #navigation-drawer .user-menu-item {
   min-height: 44px;
   padding: 0 12px;
   }
   #navigation-drawer .user-menu-item .v-list-item__title {
   color: var(--color-slate-900);
   }
   .no-padding{
       padding-left: 0px !important;
   }
   @media (max-width: 1264px) {
      .app-header .v-toolbar__content {
      padding: 0 12px;
      }
      .app-header__brand {
      min-width: 200px;
      }
   }
   @media (max-width: 959px) {
      .app-header {
      height: 84px !important;
      max-height: 84px !important;
      }
      .app-header .v-toolbar__content {
      min-height: 74px !important;
      height: 74px !important;
      }
      .app-header__brand {
      min-width: 190px;
      height: 52px;
      }
      .app-header__brand-logo {
      max-width: 200px !important;
      }
      .app-footer {
      min-height: 0 !important;
      }
      .app-footer__inner {
      max-width: 100%;
      grid-template-columns: 1fr;
      align-items: start;
      row-gap: 16px;
      padding: 20px 14px 10px;
      column-gap: 0;
      }
      .app-footer__center {
      justify-content: flex-start;
      }
      .app-footer__right {
      justify-self: start;
      }
      .app-footer__guidance,
      .app-footer__line {
      font-size: 0.9rem;
      }
      .app-footer__logo {
      width: min(320px, 100%);
      height: auto;
      }
      .app-footer__icon {
      width: 18px;
      height: 18px;
      flex-basis: 18px;
      }
      .app-footer__bottom {
      font-size: 0.85rem;
      padding: 0 0 12px;
      gap: 10px;
      justify-content: flex-start;
      }
   }
</style>

